import Pill from 'LuxKit/Pill'
import React from 'react'
import styled from 'styled-components'

const DiscountPill = styled(Pill)`
  max-width: fit-content;

  @media print {
    display: none;
  }
`

interface Props extends Utils.PropsWithDataAttributes {
  /**
   * Controls whether the messaging to state the saving is an estimate or exact value.
   * @default estimate
   */
  type?: 'exact' | 'estimate'
  /**
   * @example 10 => 10%
   */
  discountPercentage: number
  className?: string
}

function PriceRowValueDiscount(props: Props) {
  const {
    type = 'estimate',
    discountPercentage,
    ...rest
  } = props

  return <DiscountPill
    {...rest}
    kind="primary"
    variant="success"
  >
    {type === 'estimate' ? 'Save up to' : 'Save'} {discountPercentage}%
  </DiscountPill>
}

export default PriceRowValueDiscount
